import { useStaticQuery, graphql } from "gatsby";

const FooterQuery = () => {
  const footerData = useStaticQuery(graphql`
    query FooterDataQuery {
      allSanityFooter {
        nodes {
          ...sanityFooter
        }
      }
    }
  `);

  const {
    allSanityFooter: { nodes },
  } = footerData;

  const selectedFooter = nodes.find(
    node => node.region?.iban === process.env.GATSBY_IBAN
  );

  return selectedFooter;
};

export default FooterQuery;
